import React from "react";
import virtualStudiosLogo from "../assets/vr_logo_1024x1024.webp";
import "./VrPortalLogo.css";

// The Virtual Realms Studios badge. Hovering it brings the realm through its stone doorway to
// life, a little dragon flying across its sky (VrPortalLogo.css); the rest of the badge stays
// still. Props go to the <img>, so size it there; margins belong on a parent, since the doorway
// overlay is laid out against the wrapper.
export default function VrPortalLogo({alt = "Virtual Realms Studios", ...imgProps}) {
    return (
        <span className="vr-portal">
            <img src={virtualStudiosLogo} alt={alt} {...imgProps}/>
            <span className="vr-portal-door" aria-hidden="true">
                <span className="vr-portal-dragon"/>
            </span>
        </span>
    );
}
